import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, AlertTriangle } from 'lucide-react';
export function ProductDetails() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const isUrgent = timeLeft < 5 * 60;
  return <section className="py-8 sm:py-14 bg-[#111827] relative overflow-hidden" data-id="element-97">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1e6bb8]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-98" />

      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-100">
          <div className="relative" data-id="element-101">
            <div className="absolute -inset-4 bg-gradient-to-r from-[#d4a853] to-[#1e6bb8] rounded-2xl opacity-20 blur-lg" data-id="element-102" />
            <img src="https://cdn.magicpatterns.com/uploads/iaASZCvp3GDtBLvFvD1Eaf/Libro_Digital.jpg" alt="Ebook Preview" className="relative rounded-xl shadow-2xl border border-[#ffffff]/10 w-full" data-id="element-103" />

            {/* Pricing Badge */}
            <div id="precio" className="relative mt-6 flex flex-col items-center gap-2 bg-[#0a0e17]/80 backdrop-blur-md border border-[#d4a853]/30 rounded-xl p-6 shadow-lg" data-id="element-104">
              {/* Urgency Alert - inline */}
              <div className="w-full flex items-center justify-center gap-1.5 bg-red-500/10 border border-red-500/40 rounded px-3 py-1.5 mb-1 animate-pulse" data-id="element-105">
                <AlertTriangle className="w-3 h-3 text-red-400 shrink-0" data-id="element-106" />
                <span className="text-red-400 text-[10px] sm:text-xs font-bold uppercase tracking-tight whitespace-nowrap" data-id="element-107">
                  ⚠ Últimos 20 cupos — luego se cierra el acceso
                </span>
              </div>

              <span className="text-sm uppercase tracking-widest text-[#9ca3af] font-medium" data-id="element-108">
                Precio especial
              </span>
              <div className="flex items-center gap-4" data-id="element-109">
                <span className="text-2xl text-[#9ca3af]/60 line-through font-medium" data-id="element-110">
                  $1.194
                </span>
                <span className="text-5xl font-bold text-[#d4a853]" data-id="element-111">$597</span>
              </div>
              <span className="text-xs text-green-400 font-semibold tracking-wide uppercase mt-1" data-id="element-112">
                50% de descuento — Oferta limitada
              </span>

              {/* Countdown Timer */}
              <div className={`w-full mt-3 p-3 rounded-lg border text-center transition-colors duration-300 ${isUrgent ? 'bg-red-500/10 border-red-500/40' : 'bg-[#d4a853]/5 border-[#d4a853]/20'}`} data-id="element-113">
                <p className={`text-xs font-medium mb-1.5 ${isUrgent ? 'text-red-400' : 'text-[#9ca3af]'}`} data-id="element-114">
                  Tu descuento está reservado por
                </p>
                <div className="flex items-center justify-center gap-1.5" data-id="element-115">
                  <Clock className={`w-4 h-4 ${isUrgent ? 'text-red-400 animate-pulse' : 'text-[#d4a853]'}`} data-id="element-116" />
                  <span className={`text-2xl font-bold tabular-nums tracking-wider ${isUrgent ? 'text-red-400' : 'text-white'}`} data-id="element-117">
                    {String(minutes).padStart(2, '0')}:
                    {String(seconds).padStart(2, '0')}
                  </span>
                </div>
                <p className={`text-[10px] mt-1.5 ${isUrgent ? 'text-red-400/70' : 'text-[#9ca3af]/50'}`} data-id="element-118">
                  {timeLeft > 0 ? 'Al finalizar, el precio volverá a su valor original' : 'Tu reserva ha expirado — el descuento puede no estar disponible'}
                </p>
              </div>

              <button className="mt-4 w-full group inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-[#16a34a] rounded-lg hover:bg-[#22c55e] hover:scale-105 hover:shadow-[0_0_30px_rgba(34,197,94,0.5)]" data-id="element-119">
                <span data-id="element-120">QUIERO MI MÁSTER AHORA</span>
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-121" />
              </button>
              <p className="text-xs text-[#9ca3af]/60 mt-2" data-id="element-122">
                Acceso inmediato • Pago seguro
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}